module.exports = "/_next/static/images/1dbaa62b4e3da0f93f7b6b4f418808a1-gaby-meza.png";